import request from '@/utils/request'

// 查询【通用】活动信息列表
export function activityBean(query) {
  console.log(query)
  return request({
    url: '/dev-api/app/activity/general/bean',
    method: 'get',
    headers: {'token': query.token, 'request-agent': 'Android'},
    params: query
  })
}

//判断是否显示
export function isError(query) {
  return request({
    url: '/dev-api/app/activity/is/error',
    method: 'get',
    headers: {'token': query.token, 'request-agent': 'Android'},
    params: query
  })
}
//查询用户性别
export function userSex(query) {
  return request({
    url: '/dev-api/app/activity/user/sex',
    method: 'get',
    headers: {'token': query.token, 'request-agent': 'Android'},
    params: query
  })
}



// WEBPACK FOOTER //
// ./src/api/activity/activity.js